(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (function() {
  /**
   * PDP DYNAMIC PRICE
   * - Uses sacProdId to scope to the current PDP
   */
  function initDynamicPricePDP() {
    // Only run if sacProdId is defined (product pages)
    if (typeof sacProdId === 'undefined' || !sacProdId) return;

    var currentProductId = String(sacProdId);

    // Price boxes belonging to this product only
    var priceBoxes = document.querySelectorAll(
      '[data-dynamic-price][data-product-id="' + currentProductId + '"]'
    );
    if (!priceBoxes.length) return;

    // Variant JSON (inside variant-selects)
    var variantScript = document.querySelector('variant-selects script[type="application/json"]');
    if (!variantScript) return;

    var variants;
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (e) {
      console.error('PDP dynamic price: invalid JSON', e);
      return;
    }

    function findVariant(id) {
      id = Number(id);
      return variants.find(function(v) { return v.id === id; });
    }

    function money(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updatePrices(variant) {
      if (!variant) return;
      var p = variant.price;
      var c = variant.compare_at_price;

      priceBoxes.forEach(function(box) {
        var reg    = box.querySelector('[data-regular-price]');
        var sale   = box.querySelector('[data-sale-price]');
        var comp   = box.querySelector('[data-compare-price]');
        var saveEl = box.querySelector('[data-savings]');

        if (!reg || !sale || !comp) return;

        reg.textContent  = money(p);
        sale.textContent = money(p);

        if (c && c > p) {
          comp.textContent      = money(c);
          comp.style.display    = 'inline';
          box.classList.add('price--on-sale');

          // Recalculate savings text if element exists
          if (saveEl) {
            var save = c - p;
            saveEl.textContent = '(save ' + money(save) + ')';
          }

          // PDP: show sale block, hide regular block
          var regWrap  = reg.closest('.price__regular');
          var saleWrap = sale.closest('.price__sale');
          if (regWrap)  regWrap.style.display  = 'none';
          if (saleWrap) saleWrap.style.display = 'block';
        } else {
          comp.textContent      = '';
          comp.style.display    = 'none';
          box.classList.remove('price--on-sale');

          if (saveEl) saveEl.textContent = '';

          var regWrap2  = reg.closest('.price__regular');
          var saleWrap2 = sale.closest('.price__sale');
          if (regWrap2)  regWrap2.style.display  = 'block';
          if (saleWrap2) saleWrap2.style.display = 'none';
        }
      });
    }

    // Initial sync from hidden variant ID
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && idInput.value) {
      updatePrices(findVariant(idInput.value));
    }

    // Listen for changes to ID select & hidden inputs
    document.addEventListener('change', function(evt) {
      var t = evt.target;

      if (
        t.matches('select[name="id"]') ||
        (t.matches('input[name="id"]') && t.closest('form[action*="/cart/add"]'))
      ) {
        updatePrices(findVariant(t.value));
      }
    });

    // Also listen to theme variant events if present
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) updatePrices(e.detail.variant);
    });
    document.addEventListener('product:variant-change', function(e) {
      if (e.detail && e.detail.variant) updatePrices(e.detail.variant);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDynamicPricePDP);
  } else {
    initDynamicPricePDP();
  }
})();

(function() {
  /**
   * COLLECTION CARD VARIANT + PRICE SYNC
   * - Works inside .collection-card
   * - Reads variant JSON from <script type="application/json">
   * - Derives selected options by fieldset order (option1, option2, option3)
   * - Updates:
   *   - <select name="id">
   *   - visible price / compare-at / savings
   */

  function money(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getVariantsFromCard(card) {
    var script = card.querySelector('variant-selects script[type="application/json"]');
    if (!script) return null;

    try {
      var variants = JSON.parse(script.textContent || '[]');
      return Array.isArray(variants) && variants.length ? variants : null;
    } catch (e) {
      console.error('[collection-card] invalid variant JSON', e);
      return null;
    }
  }

  function getSelectedOptionsForCard(card) {
    var options = [];

    // Use fieldset order as option1, option2, option3
    var fieldsets = card.querySelectorAll('variant-selects fieldset');
    fieldsets.forEach(function(fs) {
      // Try radio first
      var radio = fs.querySelector('input[type="radio"]:checked');
      if (radio && radio.value) {
        options.push(radio.value);
        return;
      }

      // Then try a select inside this fieldset (if using dropdowns)
      var select = fs.querySelector('select[name^="options["]');
      if (select && select.value) {
        options.push(select.value);
      }
    });

    return options;
  }

  function findVariantByOptions(variants, selectedOptions) {
    if (!variants || !selectedOptions.length) return null;

    return variants.find(function(v) {
      return v.options.every(function(val, i) {
        return val === selectedOptions[i];
      });
    }) || null;
  }

  function updateCardPrice(card, variant) {
    if (!card || !variant) return;

    var priceBox = card.querySelector('[data-dynamic-price]');
    if (!priceBox) return;

    var reg    = priceBox.querySelector('[data-regular-price]');
    var sale   = priceBox.querySelector('[data-sale-price]');
    var comp   = priceBox.querySelector('[data-compare-price]');
    var saveEl = priceBox.querySelector('[data-savings]');

    if (!reg || !sale || !comp) return;

    var p = variant.price;
    var c = variant.compare_at_price;

    reg.textContent  = money(p);
    sale.textContent = money(p);

    if (c && c > p) {
      comp.textContent   = money(c);
      comp.style.display = 'inline';
      priceBox.classList.add('price--on-sale');

      if (saveEl) {
        var save = c - p;
        saveEl.textContent = '(save ' + money(save) + ')';
      }
    } else {
      comp.textContent   = '';
      comp.style.display = 'none';
      priceBox.classList.remove('price--on-sale');

      if (saveEl) {
        saveEl.textContent = '';
      }
    }

    // Keep hidden/select variant ID in sync for ATC forms
    var idSelect = card.querySelector('select[name="id"], input[name="id"]');
    if (idSelect) {
      idSelect.value = String(variant.id);
    }
  }

  document.addEventListener('change', function(evt) {
    var target = evt.target;

    // Only care about events happening inside a .collection-card
    var card = target.closest('.collection-card');
    if (!card) return;

    var variants = getVariantsFromCard(card);
    if (!variants) return;

    var selectedOptions = getSelectedOptionsForCard(card);
    if (!selectedOptions.length) return;

    var matched = findVariantByOptions(variants, selectedOptions);
    if (!matched) return;

    updateCardPrice(card, matched);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
